import { render } from "./panel-time-pick.vue?vue&type=template&id=c96811d0&ts=true"
import script from "./panel-time-pick.vue?vue&type=script&lang=ts"
export * from "./panel-time-pick.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__